import { render, staticRenderFns } from "./anexo.vue?vue&type=template&id=405df4ef&"
import script from "./anexo.vue?vue&type=script&lang=js&"
export * from "./anexo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports